import type { ListingOfferCardProps } from 'app/types/listing-offer-card-props';
import { useUISize } from 'app/utils/web-helpers';
import { ListingOfferCardSmall, OFFER_CARD_HEIGHT, OFFER_CARD_WIDTH } from './listing-offer-card.small';
import { ListingOfferCardLarge } from './listing-offer-card.large';

export type { ListingOfferCardProps };
export { OFFER_CARD_HEIGHT, OFFER_CARD_WIDTH };

export function ListingOfferCard(props: ListingOfferCardProps) {
  const { isSmallUI } = useUISize();
  if (isSmallUI) {
    return <ListingOfferCardSmall {...props} />;
  }
  return <ListingOfferCardLarge {...props} />;
}
